import { Modal, Form, Select } from "antd";
import { useEffect } from "react";

export default function SubscribeObjectsModal({ open, options, onCancel, onConfirm }) {
  const [form] = Form.useForm();
  const objects = Form.useWatch("objects", form);

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ objects: options.map((o) => o.value) });
    }
  }, [open, options, form]);

  return (
    <Modal
      open={open}
      title="Добавить подписку"
      okText="Добавить"
      cancelText="Отмена"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        const ids = form.getFieldValue("objects") || [];
        onConfirm(ids);
        form.resetFields();
      }}
      okButtonProps={{ disabled: !(objects && objects.length) }}
      width={600}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ flex: "120px" }}
        wrapperCol={{ flex: "auto" }}
        colon={false}
        style={{ display: "flex", flexDirection: "column", gap: 16 }}
      >
        <Form.Item label="Объекты раздела" name="objects" style={{ margin: 0 }}>
          <Select
            mode="multiple"
            allowClear
            options={options}
            placeholder="Выберите объекты"
            maxTagCount="responsive"
            style={{
              width: "100%",
              border: "none",
              boxShadow: "none",
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
